import { render, staticRenderFns } from "./PlotRecommender.vue?vue&type=template&id=79193288"
import script from "./PlotRecommender.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlotRecommender.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlotRecommender.vue?vue&type=style&index=0&id=79193288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports